export  class SessionTimerSitecoreTemplate {
    public SessionTimerHeader: string;
    public SessionTimerOkButtonText: string;
    public SessionTimerTextAfterTimer: string;
    public SessionTimerTextBeforeTimer: string;
}
